import MenuItemDivider from './MenuItemDivider'

export default MenuItemDivider
